module.exports = __webpack_public_path__ + "img/grey_017.920ffcef.png";